import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { propertyCardBadgeRecipe } from './styles/property-card-badge.styles';
import type { PropertyCardBadgePropsInterface } from './types/property-card-badge.types';

/**
 * Used by `PropertyCard` to highlight a particular piece of information
 * about a property. By default, the badge appears in the top-left corner of the card,
 * atop the property photo.
 *
 * @since 8.63.0
 */
export const PropertyCardBadge = forwardRef<HTMLSpanElement, PropertyCardBadgePropsInterface>(
  (props: PropertyCardBadgePropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, lineClamp = 1, tone = 'default', ...rest } = props;

    const styles = css({ lineClamp }, propertyCardBadgeRecipe.raw({ tone }), cssProp);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="PropertyCard.Badge"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </span>
    );
  },
);

PropertyCardBadge.displayName = 'PropertyCard.Badge';
